import { waitForElementToLoad } from "@/helpers/loader-utils";
import { useEffect, useState } from "react";
import { domElementIds } from "@/styles/constants";

const { navbarId, headerDetailsId } = domElementIds;

/**
 * Returns whether to display the info section on the HeaderAction component
 * If the user scrolls past the main navbar and header details component, then show the info
 * Else hide the info
 */
const useShowHeaderActionInfo = (): boolean => {
  const [showHeader, setShowHeader] = useState(false);

  const handleScroll = () => {
    const position = window.pageYOffset;
    // get the height of the main navbar at the top of the page
    const bannerHeight = document?.getElementById(navbarId)?.scrollHeight ?? 0;
    // get the height of the event details header
    const headerDetailsHeight =
      document?.getElementById(headerDetailsId)?.scrollHeight ?? 0;

    const headerHeight = bannerHeight + headerDetailsHeight;

    if (position > headerHeight) {
      setShowHeader(true);
    } else {
      setShowHeader(false);
    }
  };

  // handle info display on the HeaderAction component
  useEffect(() => {
    waitForElementToLoad(`#${navbarId}`).then(() => {
      waitForElementToLoad(`#${headerDetailsId}`).then(() => {
        // add event listener for scrolling action
        window.addEventListener("scroll", handleScroll, { passive: true });
      });
    });

    // clean up event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
    // this useEffect should only run once, so no dependencies
  }, []); // eslint-disable-line

  return showHeader;
};

export default useShowHeaderActionInfo;
